import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/projectdepartments/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointDelete: `${config.endpoints.backend}projects/delete`,
        endpoint: config.endpoints.backend + 'projects/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Projetos',
        labelTitleButtonAdd: 'Incluir novo projeto',
        fieldsShowOnDelete: ['project_name'],
        showPrintButtons: true,
        formFilters: !profileFilter.pdc_entity_id ? filters : null,
        canAdd: false,
        canDelete: false,
        filter: {
            ...profileFilter,
            hasDepartmentOrder: true
        },
        columns: [
            {
                name: 'entity',
                label: 'Entidade'
            },
            {
                name: 'project_name',
                label: 'Nome do Projeto'
            },
            {
                name: 'hasDepartment',
                label: 'Departamento Configurado',
                cell: (row) => {
                    const statusColors = {
                        true: '#38a169',
                        false: '#ff1e1eff',
                    };
                    const color = statusColors[row.hasDepartment] || '#a0aec0';
                    return (
                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{
                                display: 'inline-block',
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                backgroundColor: color,
                                flexShrink: 0,
                            }} />
                            {row.hasDepartment ? 'Sim' : 'Não'}
                        </span>
                    );
                }
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                canAdd={list.canAdd}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
